// LIBRARIES //
import React, { useState, useEffect } from 'react';
import { TextArea, AntdButton, Summary, colors } from '@yuhuinc/ui-library';
import { connect } from 'react-redux';
import styled from 'styled-components';
import moment from 'moment';
import startCase from 'lodash/startCase';

// COMPONENTS //
import CardHeader from '../CardComponent/CardHeader';
import CardBody from '../CardComponent/CardBody';

// HELPERS //
import { getTranslatedString } from 'helpers/i18n';
import { buttonColors } from '../ButtonColors';

// ACTIONS //
import { getTenantNotes, submitNote } from 'actions/landlordTenantsActions';

const StyledNote = styled.div`
  background: #f4f4f4;
  padding: 16px 50px 14px 16px;
  border-radius: 8px;
  margin-top: 18px;
`;

const StyledNoteDate = styled.span`
  line-height: 20px;
  font-size: 12px;
  color: ${colors.colors.gray[7]};
  display: block;
`;

const StyledNoteTitle = styled.span`
  line-height: 22px;
  font-size: 14px;
  color: ${colors.colors.gray[9]};
  display: block;
  margin-bottom: 6px;
`;

const StyledNoteBody = styled.span`
  line-height: 18px;
  font-size: 14px;
  color: ${colors.colors.gray[7]};
  display: block;
`;

const StyledButton = styled(AntdButton)`
  margin-top: 32px;
  margin-bottom: 32px;
`;

const StyledHeader = styled.p`
  line-height: 24px;
  font-size: 16px;
`;

const Note = ({ noteData }) => (
  <StyledNote>
    <StyledNoteDate>{startCase(moment(noteData.time).format('MMM DD, YYYY'))}</StyledNoteDate>
    <StyledNoteTitle>{noteData.title}</StyledNoteTitle>
    <StyledNoteBody>{noteData.verbiage.join('\n')}</StyledNoteBody>
  </StyledNote>
);

const Notes = ({ leadId, getTenantNotes, residentNotes, submitNote }) => {
  useEffect(() => {
    getTenantNotes(leadId);
  }, [getTenantNotes, leadId]);

  const [noteText, setNoteText] = useState(null);

  const submitCallback = async () => {
    if (!noteText) return null;

    const formData = { text: noteText };

    await submitNote(formData, leadId);
    await setNoteText(null);
    getTenantNotes(leadId);
  };

  return (
    <div>
      <CardHeader>
        {getTranslatedString('residentDrawer.residentDetailsTab.notes.title')}
      </CardHeader>
      <CardBody>
        <StyledHeader>
          {getTranslatedString('residentDrawer.residentDetailsTab.notes.textbox.title')}
        </StyledHeader>
        <TextArea
          value={noteText}
          onChange={(evt) => setNoteText(evt.target.value)}
          placeholder={getTranslatedString(
            'residentDrawer.residentDetailsTab.notes.textbox.placeholder'
          )}
        />
        <StyledButton
          label={getTranslatedString('residentDrawer.residentDetailsTab.notes.button')}
          onClick={submitCallback}
          style={buttonColors}
        />
        <Summary
          subTitle={getTranslatedString('residentDrawer.residentDetailsTab.notes.previousNotes')}
        >
          {residentNotes.map((note) => (
            <Note noteData={note} />
          ))}
        </Summary>
      </CardBody>
    </div>
  );
};

export default connect(
  (store) => {
    return {
      residentNotes: store.landlordTenants.tenantNotes,
    };
  },
  { getTenantNotes, submitNote }
)(Notes);
